export const en = {
    '0-17': 'younger than 18',
    '18-24': '18-24',
    '25-34': '25-34',
    '35-44': '35-44',
    '45-54': '45-54',
    '55-': 'Over 55',
    'all-ages': 'all ages',
    'all-cpm-banner': 'All banners',
    'all-genders': 'Men and women',
    'all-items': 'All',
    'all-mobile': 'All smartphones',
    android: 'Android',
    cancel: 'Cancel',
    'closed-panel-description':
        "Bid adjustments allow you to raise or lower the bid in response to the user's characteristics, the ad format and even the current weather.",
    'cpm-banners': 'Banners',
    'demography-tab': 'Gender and age',
    desktops: 'Desktops',
    'device-tab': 'Devices',
    female: 'Women',
    inbanner: 'In-banner video',
    inpage: 'In-page',
    'instream-web': 'In-stream',
    interstitial: 'Interstitial',
    inventory: 'Video',
    'inventory-tab': 'Inventory',
    ios: 'iOS',
    male: 'Men',
    mobile: 'Smartphones',
    'more-info-link': 'Learn more',
    'no-value': 'Set bid adjustments to get more traffic',
    'opened-panel-description':
        'You can raise or lower the bid using coefficients. A coefficient is the percentage by which you want to change the bid. If you have multiple adjustments, they are applied one by one. {moreInfoLink}',
    'panel-description':
        'You can raise or lower the bid using coefficients. A coefficient is the percentage by which you want to change the bid. If you have multiple adjustments, they are applied one by one. {moreInfoLink}',
    ready: 'Done',
    'retargeting-tab': 'Target audience',
    rewarded: 'Rewarded video',
    'smart-banners-tab': 'Smart ads',
    title: 'Bid adjustments',
    'traffic-jam-tab': 'Traffic',
    'video-addition-tab': 'Video extensions',
    'weather-tab': 'Weather'
};
